module.exports = __webpack_public_path__ + "img/banner1.945a578b.svg";